import React, {useEffect, useMemo, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const MotherFollowupOutcomesStep: React.FC<StepComponentProps> = ({
                                                                    formData,
                                                                    updateFormData,
                                                                    onNext,
                                                                    onPrevious,
                                                                    canGoBack,
                                                                    canGoNext,
                                                                    patientCaseType,
                                                                    journey,
                                                                    motherFollowupData,
                                                                  }) => {
  const [selectedFollowup, setSelectedFollowup] = useState<string | null>(formData.motherFollowupOutcome);

  const patientCountryId = journey.patientCase?.patient?.countryId;
  const isAntepartum = journey.patientCase?.emergencyType === EmergencyType.ANTEPARTUM;

  // Filter followups for mother outcomes
  // emergencyType !== NEONATAL, isAlive based on step 4, isCondition false
  const motherFollowupOutcomes = useMemo(() => {
    return motherFollowupData?.filter(followup => {
      const baseConditions = (
        followup.isAlive === formData.motherAlive
      );

      // Only check isDelivered for antepartum cases
      if (isAntepartum) {
        return baseConditions && followup.isDelivered === formData.isDelivered;
      }

      return baseConditions;
    }) || [];
  }, [motherFollowupData, formData.motherAlive, formData.isDelivered, isAntepartum]);

  const displayFollowups = motherFollowupOutcomes;

  useEffect(() => {
    updateFormData({motherFollowupOutcome: selectedFollowup});
  }, [selectedFollowup]);

  const handleFollowupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFollowup(e.target.value);
  };

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-primary mb-4">
          Select a mother <span className="text-danger">follow-up outcome</span>
        </h6>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup
            name="motherFollowupOutcome"
            required={displayFollowups.length > 0}
            value={selectedFollowup}
            className="form-control"
            style={{overflowY: 'auto', height: '400px'}}
          >
            <Row>
              {displayFollowups.length === 0 ? (
                <Col md="12">
                  <div className="text-center py-4">
                    <div className="text-muted">No follow-up outcomes available for this patient status.</div>
                  </div>
                </Col>
              ) : (
                displayFollowups.map((followup) => (
                  <Col md="12" key={followup.id}>
                    <AvRadio
                      name="motherFollowupOutcome"
                      value={followup.id}
                      onChange={handleFollowupChange}
                      label={followup.enFollowup}
                    />
                  </Col>
                ))
              )}
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={5}
            totalSteps={10}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default MotherFollowupOutcomesStep;
